import React from "react"
import CheckMark from "@mui/icons-material/CheckCircleOutline"
import Grid from "@mui/material/Grid"

import Section from "../template-parts/product-marketing/Section"
import IconTextBlock from "../template-parts/product-marketing/IconTextBlock"
import CategoryPreview from "../template-parts/articles/CategoryPreview"
import TrustBadges from "../template-parts/product-marketing/TrustBadges"

type Props = {
  tag?: string
}

const GuaranteeNews = ({ tag }: Props) => (
  <Section
    style={{
      backgroundColor: "#fafafa",
    }}
  >
    <Grid container spacing={8} alignItems="center">
      <Grid item md={6} sm={12}>
        <div style={{ maxWidth: 500, margin: "0 auto" }}>
          <h2>The Coastline Guarantee</h2>
          <IconTextBlock
            head="A great experience or we'll make it right."
            text="If for any reason you are unsatisfied with your driving lesson,
          we will make it right. We can redo your lesson either with the same
          instructor or a different one, at your option. Or, if you prefer, you
          can get a full refund."
            icon={<CheckMark />}
          />
        </div>
        <br />
        <div style={{ maxWidth: 500, margin: "0 auto" }}>
          <TrustBadges />
        </div>
      </Grid>
      <Grid item md={6} sm={12}>
        <CategoryPreview category="news" tag={tag} />
      </Grid>
    </Grid>
  </Section>
)

export default GuaranteeNews
